export default __webpack_public_path__ + "static/media/Pollution-de l’eau.62bd62a8.svg";